import { createSeniorFlowTab } from './seniorFlowTabFactory';
import { interviewWhenColumn } from './InterviewWhenCell';
import { interviewPanelColumn } from './InterviewPanelCell';
import { registerTab } from './tabRegistry';

// senior_level_flow — "Interview" tab. Registered under "Test In Progress"
// now, not "In Progress" — confirmed live via a real GET .../flow-statuses
// response: this tab's own tabs[].filters.status went from the single
// status ["In Progress"] to a 3-way merge
// ["Test In Progress", "Interview In Progress", "In Progress"], and the
// *first* entry in that array is what this page's own `filters` derivation
// (AssignmentPipeline.jsx) uses as the tab's primary status — i.e. the key
// this registration has to match. Registering under the old key didn't
// error, it just made getTabComponent() return nothing for the new primary
// status, so the tab silently fell back to "No view configured for this
// stage yet." — same failure shape as every other sample-vs-live drift this
// flow has already hit (status→state, is_main_state→tabs[], etc.).
//
// The three merged statuses are genuinely different phases, not aliases of
// each other — each row's own manual_actions (resolved per-row already, via
// manualActionsByStatus) reflects that: "Test In Progress" only offers
// resend_test_link/reject/complete_interview_round (no reschedule_slot or
// mark_as_no_show, since there's no interview slot to reschedule or miss
// during the assessment phase); "Interview In Progress" and "In Progress"
// both offer the full set (reschedule_slot, resend_test_link, reject,
// mark_as_no_show, complete_interview_round).
// This tab alone also gets "When" + "Panel & Prep" (row.interview_details)
// — see InterviewWhenCell.jsx / InterviewPanelCell.jsx for the field
// mapping and what was deliberately left out.
const SeniorInProgressTab = createSeniorFlowTab(
  'Test In Progress',
  'No candidates are in progress right now.',
  { extraColumns: [interviewWhenColumn, interviewPanelColumn] }
);

registerTab({
  stateMachineKey: 'senior_level_flow',
  state: 'Test In Progress',
  component: SeniorInProgressTab,
});

export default SeniorInProgressTab;
